import { isSizeToken } from '@smoothie-framework/ui-core/tokens';
import { isCssWideKeyword } from './css-wide-keywords';
import { containsTokenReferenceSyntax, isBareUtilityIdentifier, isNumericUtilityLiteral, } from './utility-value-syntax';
function classifyNumericDimensionValue(normalizedValue) {
    const numericValue = Number(normalizedValue);
    if (!Number.isFinite(numericValue)) {
        return { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (numericValue < 0) {
        return { valid: false, reason: 'negative_not_allowed', normalizedValue };
    }
    return { valid: true, kind: 'numeric', normalizedValue };
}
function isSupportedDimensionKeyword(value) {
    if (isCssWideKeyword(value)) {
        return true;
    }
    switch (value) {
        case 'auto':
        case 'screen':
        case 'stretch':
        case 'min-content':
        case 'max-content':
        case 'fit-content':
            return true;
        default:
            return false;
    }
}
export function classifyDimensionUtilityValue(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue === 'number') {
        const normalizedValue = String(rawValue);
        if (!isNumericUtilityLiteral(normalizedValue)) {
            return { valid: false, reason: 'invalid_type', normalizedValue };
        }
        return classifyNumericDimensionValue(normalizedValue);
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (isNumericUtilityLiteral(normalizedValue)) {
        return classifyNumericDimensionValue(normalizedValue);
    }
    if (isSizeToken(normalizedValue)) {
        return { valid: true, kind: 'token', normalizedValue };
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (!isSupportedDimensionKeyword(normalizedValue)) {
            return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
        }
        return { valid: true, kind: 'keyword', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
//# sourceMappingURL=dimension-values.js.map